import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Button,
	Col,
	Card,
	CardBody,
	CardTitle,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import DiscountTypeEditForm from "./DiscountTypeEditForm";

// Utilities
import {
	createNotificationHelpers,
	updateDiscountType,
} from "../utils";

class DiscountTypeEdit extends Component {
	constructor(props) {
		super(props)
		this.state = {
			store_domain: "",
			type: 'Automatic',
			discount_type: 'Automatic',
			max_discount: 0,
			loading: false,
			store_details: {},
			store_status: "",
		}

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}
	componentDidMount() {
		const { data } = this.props.location;
		if (!data) {
			return window.location.href = '/stores';
		}
		const { store_domain, max_discount, type, store_details, store_status } = data;
		this.setState({
			store_domain,
			type,
			max_discount: max_discount || 0,
			discount_type: type,
			store_details: { ...store_details },
			store_status
		})
	}
	/**
	 * Handles form submission
	 */
	handleValidSubmit = async (e) => {
		e.preventDefault();
		const { store_domain, discount_type, max_discount } = this.state;

		const success = await updateDiscountType(
			store_domain,
			discount_type,
			max_discount,
			this.notify_error
		);

		if (success) {
			this.setState({ loading: true });
			this.notify_success('Discount Type Updated Successfully');
		}
	}

	handleInputChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		})
	}


	render() {
		const { store_domain, discount_type, max_discount, type, loading, store_details, store_status } = this.state;
		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Discount Type Edit</title>
					</Helmet>
					<Container fluid>
						<Breadcrumbs
							title={("Discount Type Edit")}
							breadcrumbItem={("Edit")}
						/>
						<ToastContainer />
						<Col md={12}>
							<Card>
								<CardBody>
									<CardTitle className="h4"></CardTitle>
									<Link to={{ pathname: "/merchant-details", state: { data: store_details, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

										<Button className="btn btn-dark">
											<i className="fa fa-arrow-left"></i> Store Details
										</Button>
									</Link>
									<DiscountTypeEditForm
										store_domain={store_domain}
										discount_type={discount_type}
										max_discount={max_discount}
										type={type}
										onInputChange={this.handleInputChange}
										onSubmit={this.handleValidSubmit}
									/>
								</CardBody>
							</Card>
						</Col>

					</Container>
				</div>
			</React.Fragment>
		)
	}
}

DiscountTypeEdit.propTypes = {
	t: PropTypes.any
}
export default DiscountTypeEdit
